import React from 'react';
import { getPlaybookById } from '../../../data/playbookTaxonomy';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import StageCards from '../../../components/playbooks/StageCards';
import ToolCallout from '../../../components/playbooks/ToolCallout';
import { 
  RocketLaunchIcon,
  MagnifyingGlassIcon,
  ArrowPathIcon,
  ChartBarIcon,
  DocumentTextIcon,
  WrenchScrewdriverIcon,
  BookOpenIcon
} from '@heroicons/react/24/outline';

const EmployerBrandHowToExecute = () => {
  const playbookId = 'employer-brand-unfiltered';
  const playbook = getPlaybookById(playbookId);
  const stageIcons = {
    'stage-1': <MagnifyingGlassIcon className="h-7 w-7 text-primary-light" />,
    'stage-2': <ArrowPathIcon className="h-7 w-7 text-primary-light" />,
    'stage-3': <ChartBarIcon className="h-7 w-7 text-primary-light" />,
  };

  return (
    <PlaybookSection
      title="How To Execute"
      icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />}
      heading="Getting Started with Your Authentic Employer Brand"
    >
      <div className="prose prose-invert max-w-none space-y-8">
        <p className="text-gray-300">
          This playbook is designed to help you build an authentic employer brand that attracts and repels the right talent. We'll guide you through three key stages: discovering your true EVP, embedding it internally and activating it externally, and building a sustainable feedback loop to keep it authentic.
        </p>

        <div className="mt-8">
          <StageCards
            stages={playbook.sections.filter(section => section.id.startsWith('stage-'))}
            icons={stageIcons}
            playbookId={playbookId}
            introText="Each stage builds upon the previous one, creating a comprehensive approach to authentic employer branding:"
          />
        </div>

        
      </div>
    </PlaybookSection>
  );
};

export default EmployerBrandHowToExecute; 